module.exports = __webpack_public_path__ + "assets/Schnupfen.48d41423.png";